var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","to":{name: 'mail'}}},[_c('v-badge',{attrs:{"color":"red","content":_vm.messages,"value":_vm.messages}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mail")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }